package org.vreo.devicehub.features.core.presentation.components.byteArrayToBitmap

import org.jetbrains.skia.Image

import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap

actual fun ByteArray.toImageBitmap(): ImageBitmap? {
    return Image.makeFromEncoded(this).toComposeImageBitmap()
}